import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const CaretPrevious = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='CaretPrevious' {...props}>
    <polygon fill='none' stroke='#000' strokeWidth='2' points='6 2 18 12 6 22' transform='matrix(-1 0 0 1 24 0)' />
  </StyledIcon>
);
